import { render, staticRenderFns } from "./lxcgDetail.vue?vue&type=template&id=62771cfe&scoped=true&"
import script from "./lxcgDetail.vue?vue&type=script&lang=js&"
export * from "./lxcgDetail.vue?vue&type=script&lang=js&"
import style0 from "./lxcgDetail.vue?vue&type=style&index=0&id=62771cfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62771cfe",
  null
  
)

export default component.exports